module.exports = "<div class=\"score\">\n\t<p>Score <span data-rpoint=\"score\">1000</span></p>\n</div>\n";